import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap } from 'react-google-maps';

import MarkerComponent from 'components/MarkerComponent';

class MapComponent extends React.Component {
  renderMarkers = () => {
    const {
      activeId,
      displayMoreInfo,
      handleToggleClose,
      handleToggleOpen,
      locations,
      markerIcon,
    } = this.props;
    return locations.map((location, index) => {
      return (
        <MarkerComponent
          activeId={activeId}
          displayMoreInfo={displayMoreInfo}
          key={index}
          handleToggleClose={handleToggleClose}
          handleToggleOpen={handleToggleOpen}
          location={location}
          markerIcon={markerIcon}
        />
      );
    });
  };

  render() {
    const { center, defaultOptions, zoom } = this.props;
    return (
      <GoogleMap
        center={center}
        defaultCenter={center}
        defaultOptions={defaultOptions}
        defaultZoom={zoom}
        zoom={zoom}
      >
        <React.Fragment>{this.renderMarkers()}</React.Fragment>
      </GoogleMap>
    );
  }
}

export default MapComponent;

MapComponent.propTypes = {
  activeId: PropTypes.number,
  center: PropTypes.object.isRequired,
  defaultOptions: PropTypes.object.isRequired,
  defaultStyles: PropTypes.arrayOf(PropTypes.object),
  displayMoreInfo: PropTypes.bool.isRequired,
  handleToggleClose: PropTypes.func.isRequired,
  handleToggleOpen: PropTypes.func.isRequired,
  markerIcon: PropTypes.string,
  zoom: PropTypes.number.isRequired,
};
